import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import RxGhgAccordion from "./RxGhgAccordion";

export default function MaterialsChipsPanel({ receiverMaterialQuantities }) {
  const { t } = useTranslation();

  const materialsCount = Array.isArray(receiverMaterialQuantities)
    ? receiverMaterialQuantities.length
    : 0;

  return (
    <Box className="rxghg_block">
      <RxGhgAccordion
        id="rxghg_materials"
        title={t("ghg.materials.title", "Material quantities in report range")}
        subtitle={t(
          "ghg.materials.subtitle",
          "Sum of delivered quantities by material type"
        )}
        rightEl={
          <Box className="rxghg_accBadges">
            <span className="rxghg_badge">
              {t("ghg.materials.badges.materialsCount", "{{count}} materials", {
                count: materialsCount,
              })}
            </span>
          </Box>
        }
      >
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {materialsCount === 0 ? (
            <Typography variant="body2" sx={{ opacity: 0.75 }}>
              {t(
                "ghg.common.noDeliveredRequestsInDateRange",
                "No delivered requests in selected date range."
              )}
            </Typography>
          ) : (
            receiverMaterialQuantities.slice(0, 60).map((r) => (
              <Chip
                key={r.material}
                label={`${r.material}: ${Number(r.qty).toFixed(2)}`}
                size="small"
                variant="outlined"
                className="rxghg_chip"
              />
            ))
          )}
        </Box>
      </RxGhgAccordion>
    </Box>
  );
}